import {Tooltip, Typography} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";
import HelpIcon from '@material-ui/icons/Help';
import React from "react";
import IconButton from "@material-ui/core/IconButton";

const TopOfferItem = (props) => {
    return (
        <Box>
            <Typography variant={"overline"}
                        color={"textSecondary"}>
                {props.item.title}
            </Typography>

            <Typography variant={"h6"}>
                {props.item.content}
            </Typography>

            {props.item.footerText ? <Box marginY={props.footerMarginY}>
                <Typography variant={"overline"}
                            color={"textSecondary"}
                            component={"span"}>
                    {props.item.footerText}
                </Typography>
                {props.item.tooltipText ? <Tooltip title={props.item.tooltipText}
                                                   arrow>
                    <IconButton color={"primary"} size={"small"}>
                        <HelpIcon color={"primary"}/>
                    </IconButton>
                </Tooltip> : null}
            </Box> : null}
        </Box>
    )
}

TopOfferItem.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string.isRequired,
        content: PropTypes.string.isRequired,
        footerText: PropTypes.string,
        tooltipText: PropTypes.string,
    }).isRequired,
    footerMarginY: PropTypes.number
}

export default TopOfferItem;
